module.exports = __webpack_public_path__ + "linea-basic-10.177764eadf43efc393eb.svg";


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/lednube/theme/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module id = ../../../../../theme/scss/icons/linea-icons/fonts/linea-basic-10.svg
// module chunks = styles